import React from 'react';
import withStyles from '@mui/styles/withStyles';
import {FormControlLabel} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import PropTypes from "prop-types";

const StyledCheckbox = withStyles((theme) => ({
    root: {
        color: '#343a41b2',
        '&$checked': {
            color: 'var(--siteconfig-ui-btn-stdcolor-rgba);',
        },
    },
    checked: {},
}))(Checkbox);

const CheckboxInput = (props) => {
    return (
        <FormControlLabel
            className={props.className}
            label={props.label}
            labelPlacement={props.labelPlacement ?? 'start'}
            control={
                <StyledCheckbox
                    name={props.name}
                    checked={props.checked}
                    disabled={props.disabled}
                    onChange={props.onChange}
                    value={props.value}
                />
            }
        />
    )
}

CheckboxInput.propTypes = {
    value: PropTypes.any,
}

CheckboxInput.defaultProps = {
    value: 'on'
}

export default CheckboxInput;
